import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { RenameContent } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface RenameContentAction extends Action {
  content: IContentInfo;
}

export function renameContent(content: IContentInfo): RenameContentAction {
  return {
    type: RenameContent,
    content
  };
}

export const isRenameContentAction = isActionFactory<RenameContentAction>(RenameContent);
